module.exports = __webpack_public_path__ + "img/editPage_coupon_coupon.c93b43f9.svg";